import { FunctionComponent } from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { PropsWithChildren } from 'react';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            boxSizing: 'border-box',
            [theme.breakpoints.down(768)]: {
                paddingLeft: '16px',
                paddingRight: '16px',
                paddingBottom: '16px'
            },
            [theme.breakpoints.between(768, 'md')]: {
                paddingLeft: '30px',
                paddingRight: '85px',
                paddingBottom: '26px'
            },
            [theme.breakpoints.up('lg')]: {
                paddingLeft: '37px',
                paddingRight: '107px',
                paddingBottom: '32px'
            }
        }
    })
);

export const BodyResumeSection: FunctionComponent<PropsWithChildren> = props => {
    const classes = useStyles();

    return <Box className={classes.container}>{props.children}</Box>;
};

export default BodyResumeSection;
